import ROLES from '@/utils/roles';
import TOP_BARS from '@topBars';
let routes = [
  /**
   * @description 老师端-学生申请
   * @function /info 老师端-学生申请
   * @param { Component } Info views/school/
   * @param { Name } pathname /school-student
   */
  {
    path: '/sl/application/:step?',
    name: 'sl-application',
    meta: {
      title: 'sl端'
    },
    component: () => import('@/views/sl/Application')
  },
  /**
   * @description CCL申请
   * @function /ccl/application/:step? CCL申请
   * @param { Component } ApplicationCCL views/sl/ApplicationCCL
   * @param { Name } pathname ccl-application
   */
  {
    path: '/ccl/application/:step?',
    name: 'ccl-application',
    meta: {
      title: 'ccl端'
    },
    component: () => import('@/views/sl/ApplicationCCL')
  }
];
routes = routes.map(item => {
  let ret = Object.assign({}, item);
  ret.meta = Object.assign({}, ret.meta, {
    topBar: TOP_BARS.SL,
    role: ROLES.SL
  });
  return ret;
});
export default routes;
